import { render } from "./CampaignSlider.vue?vue&type=template&id=1170f855&scoped=true"
import script from "./CampaignSlider.vue?vue&type=script&lang=js"
export * from "./CampaignSlider.vue?vue&type=script&lang=js"

import "./CampaignSlider.vue?vue&type=style&index=0&id=1170f855&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1170f855"]])

export default __exports__